export default "__VITE_ASSET__DWeira9A__"